import { MutationKey } from '@tanstack/react-query';
import { QueryApiOptions } from '../../types/types';
import { NotifyMeSubscribeParams, postNotifyMeSubscribe } from './product.api';

export const productMutationKeys = {
  all: () => ['product'] as MutationKey,
  postNotifyMeSubscribe: () => [...productMutationKeys.all(), 'postNotifyMeSubscribe'] as MutationKey,
};

export const productMutations = (apiOptions: QueryApiOptions) => ({
  postNotifyMeSubscribe: {
    mutationKey: productMutationKeys.postNotifyMeSubscribe(),
    mutationFn: (params: NotifyMeSubscribeParams) => postNotifyMeSubscribe(apiOptions, params),
  },
});
